const tccStyles = {
    stagingColor: { primary: "#ff3d00", secondary: "#ff5722" },
    productionColor: { primary: "#07a1b5", secondary: "#0665A9" },
    snackbar: { color: "white", errorColor: "#bb333e" },
    changePassword: {
        dialogTitle: { padding: "10px 10px 10px", iconFontSize: 30 }
    },
    login: {
        button: { backgroundColor: "#337AB7" },
        infoline: { iconColor: "#bdbdbd" }
    },
    progressBar: {
        color: {
            running: "#00bcd4",
            succeeded: "#87d068",
            error: "#f50"
        }
    },
    fields: {
        borders: {
            bottomBorderError: "2px solid red",
            bottomBorder: "1px solid lightgrey",
            bottomBorderHover: "1px solid black"
        }
    },
    colors: {
        main: "grey",
        error: "red",
        black: "black",
        white: "white",
        lightgrey: "lightgrey"
    }
};

export default tccStyles;



// WEBPACK FOOTER //
// ./src/common/styles.js